/**
 * Hover Image with Scroll Reveal
 * 
 * This script enables secondary product images to be revealed on scroll
 * for both mobile and desktop experiences based on theme settings.
 */

class HoverImageScroll {
  constructor(options = {}) {
    this.mediaContainers = document.querySelectorAll('.product-media-container');
    this.isMobile = window.innerWidth < 750;
    this.scrollTimeout = null;
    this.scrolling = false;
    
    // Default options
    this.options = {
      enableMobile: true,
      enableDesktop: false,
      transitionDuration: 250, // ms
      scrollStopDelay: 150, // ms
      ...options
    };
    
    this.init();
  }

  init() {
    if (this.mediaContainers.length === 0) return;
    
    // Apply transition duration from settings to CSS variable
    document.documentElement.style.setProperty('--hover-scroll-transition', `${this.options.transitionDuration}ms`);
    
    // Add scroll reveal class to all containers with hover images
    this.mediaContainers.forEach(container => {
      const hoverImage = container.querySelector('.hover-image');
      if (hoverImage) {
        container.classList.add('scroll-reveal-active');
      }
    });
    
    // Add scroll event listener
    window.addEventListener('scroll', this.handleScroll.bind(this));
    
    // Handle resize events to update mobile status
    window.addEventListener('resize', this.handleResize.bind(this));
  }
  
  handleScroll() {
    // Check if scroll effect is enabled for the current device
    if ((this.isMobile && !this.options.enableMobile) || (!this.isMobile && !this.options.enableDesktop)) {
      return;
    }
    
    // Clear previous timeout
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout);
    }
    
    // Set scrolling state to true
    if (!this.scrolling) {
      this.scrolling = true;
      this.revealHoverImages();
    }
    
    // Set a timeout to detect when scrolling has stopped
    this.scrollTimeout = setTimeout(() => {
      this.scrolling = false;
      this.hideHoverImages();
    }, this.options.scrollStopDelay); // Use the configured delay before hiding images
  }
  
  revealHoverImages() {
    this.mediaContainers.forEach(container => {
      if (!container.classList.contains('scroll-reveal-active')) return;
      
      const rect = container.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      
      // If container is visible in the viewport
      if (rect.top < viewportHeight && rect.bottom > 0) {
        container.classList.add('revealed');
      }
    });
  }
  
  hideHoverImages() {
    this.mediaContainers.forEach(container => {
      container.classList.remove('revealed');
    });
  }
  
  handleResize() {
    this.isMobile = window.innerWidth < 750;
  }
}

// Initialize on DOM content loaded if not being initialized by section
if (typeof window.HoverImageScroll === 'undefined') {
  document.addEventListener('DOMContentLoaded', () => {
    // Check if specific initialization hasn't already happened via a section
    if (!window.hoverImageScrollInstance) {
      window.hoverImageScrollInstance = new HoverImageScroll();
    }
  });
}

// Make the class globally available
window.HoverImageScroll = HoverImageScroll; 